<template>
    <div class="scroll" ref="scroll" :class="scrollClass">
        <div class="scroll-content" ref="scroll-content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
const addEvent = function(obj,type,func){
    if(obj.addEventListener){
        obj.addEventListener(type,func,false);//默认false可省略
    }else{
        obj.attachEvent("on"+type,func);
    }
}
const removeEvent = function(obj,type,func){
    if(obj.removeEventListener){
        obj.removeEventListener(type,func,false);//默认false可省略
    }else{
        obj.detachEvent("on"+type,func);
    }
}
const map = new WeakMap();
const ob = new ResizeObserver((entries)=>{
    for(let entry of entries){
        let handler = map.get(entry.target);
        if(handler)handler();
    }
})
const getElementByAttr = function(parentEL = document, tag, reg){
    let aElements = parentEL.querySelectorAll(tag);
    let aEle = [];
    aElements.forEach(el=>{
        var attrs = el.getAttributeNames();
        if(attrs.filter(attr => reg.test(attr)).length > 0){
            aEle.push(el);
        }
    })
    return aEle;
}
export default {
    name:"Scroll",
    props:{
        direction:{
            type: String,
            default: 'vertical',
            validator: val=>['vertical', 'horizontal'].includes(val)
        },
        scroll:{
            type: Number,
            default: 0
        },
        offset: {
            type: Number,
            default: 3
        },
        lazy: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            currentScroll: 0,
            contentDom: null
        }
    },
    watch:{
        //兼容 20204-11-20 前 旧页面
        scroll(newRoll){
            let currentScroll = this.currentScroll;
            if(currentScroll == newRoll) return;
            newRoll = newRoll <= 0 ? 0 : newRoll;
            this.scrollTo({
                scrollTop: newRoll
            })
        }
    },
    computed:{
        scrollClass(){
            let classes = [
                this.direction == "vertical" ? "is-vertical" : "is-horizontal"
            ];
            return classes;
        }
    },
    mounted(){
        let scrollDom = this.$refs['scroll'];
        removeEvent(scrollDom, 'scroll', this.scrollChange);
        addEvent(scrollDom, 'scroll', this.scrollChange);

        this.contentDom = this.$refs['scroll-content'];
        ob.observe(this.contentDom);
        map.set(this.contentDom, ()=>{
            this.lazyLoading(this.currentScroll);
        })
    },
    activated(){
        let scrollDom = this.$refs['scroll'];
        if(this.direction == "vertical"){
            scrollDom.scrollTo({
                top: this.currentScroll,
                behavior: 'instant'
            });
        }else{
            scrollDom.scrollTo({
                left: this.currentScroll,
                behavior: 'instant'
            });
        }
    },
    destroyed(){
        ob.unobserve(this.contentDom);
    },
    methods:{
        scrollChange(e){
            e = e || event;
            let scrollDom = this.$refs['scroll'];
            if(this.direction == "vertical"){
                let scrollTop = scrollDom.scrollTop;
                let scrollHeight = scrollDom.scrollHeight, 
                    clientHeight = scrollDom.clientHeight;
                if(scrollHeight < scrollTop + clientHeight + this.offset){
                    this.$emit('scrollEnd', scrollTop, e);
                }
                this.currentScroll = scrollTop;
                this.$emit('update:scroll', scrollTop);
                this.$emit('scrollChange', scrollTop, e);
                this.lazyLoading(scrollTop);
            }else{
                let scrollLeft = scrollDom.scrollLeft;
                let scrollWidth = scrollDom.scrollWidth, 
                    clientWidth = scrollDom.clientWidth;
                if(scrollWidth < scrollLeft + clientWidth + this.offset){
                    this.$emit('scrollEnd', scrollLeft, e);
                }
                this.currentScroll = scrollLeft;
                this.$emit('update:scroll', scrollLeft);
                this.$emit('scrollChange', scrollLeft, e);
            }
        },
        scrollTo(options){
            if(!options) return;
            let {scrollTop = 0, behavior = 'smooth'} = options;
            let scrollDom = this.$refs['scroll'];
            if(this.direction == "vertical"){
                if(scrollTop != 0){
                    let scrollHeight = scrollDom.scrollHeight, 
                        clientHeight = scrollDom.clientHeight;
                    if(scrollHeight > clientHeight){
                        if(scrollHeight - clientHeight < scrollTop){
                            scrollTop = scrollHeight - clientHeight;
                        }
                    }else{
                        scrollTop = 0;
                    }
                }
                scrollDom.scrollTo({
                    top: scrollTop,
                    behavior: behavior
                })
                this.currentScroll = scrollTop;
            }else{
                let scrollLeft = scrollTop;
                if(scrollLeft != 0){
                    let scrollWidth = scrollDom.scrollWidth,
                        clientWidth = scrollDom.clientWidth;
                    if(scrollWidth > clientWidth){
                        if(scrollWidth - clientWidth < scrollLeft){
                            scrollLeft = scrollWidth - clientWidth;
                        }
                    }else{
                        scrollLeft = 0;
                    }
                }
                scrollDom.scrollTo({
                    left: scrollLeft,
                    behavior: behavior
                })
                this.currentScroll = scrollLeft;
            }
        },
        lazyLoading(scrollTop){
            if(!this.lazy) return;
            let lazyBoxs = this.contentDom.querySelectorAll('*[lazy-box]');
            if(lazyBoxs.length > 0){
                let scrollDom = this.$refs['scroll'];
                lazyBoxs.forEach((item)=>{
                    let top = item.offsetTop - scrollDom.offsetTop;
                    if(top - scrollTop < scrollDom.offsetHeight){
                        this.load(item);
                    }else{
                        return;
                    }
                })
            }
        },
        load(lazyBox){
            setTimeout(()=>{
                if(lazyBox.getAttribute('lazy-box') != null){
                    let lazyDoms = getElementByAttr(lazyBox, '*', /^lazy-/);
                    if(lazyDoms.length > 0){
                        lazyDoms.forEach(domItem => {
                            let attrNames = domItem.getAttributeNames().filter(n => /^lazy-/.test(n));
                            if(attrNames && attrNames.length){
                                for(let attrName of attrNames){
                                    let attrValue = domItem.getAttribute(attrName);
                                    domItem.setAttribute(attrName.replace(/^lazy-/, ''), attrValue);
                                    domItem.removeAttribute(attrName);
                                }
                            }
                        })
                    }
                    lazyBox.removeAttribute('lazy-box');
                }
            },200)
        }
    }
};
</script>
<style lang="scss" scoped>
.scroll{
    width: 100%;
    height: 100%;
    overflow: hidden;
    &.is-horizontal{
        overflow-x: auto;
        .scroll-content{
            height: 100%;
            width: auto;
        }
    }
    &.is-vertical{
        overflow-y: auto;
        touch-action: pan-y;
        .scroll-content{
            height: auto;
            width: 100%;
        }
    }
}
</style>